import Cookies from 'js-cookie';
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

const TOKEN_KEY = 'token';
const REFRESH_TOKEN_KEY = 'refresh_token';

const isNative = () => {
  try { return Capacitor?.isNativePlatform?.() === true; } catch { return false; }
};

export const authStorage = {
  async getToken() {
    if (isNative()) {
      try {
        const { value } = await Preferences.get({ key: TOKEN_KEY });
        return value || null;
      } catch (_) { return null; }
    }
    const cookieToken = Cookies.get(TOKEN_KEY);
    if (cookieToken) return cookieToken;
    try {
      return window.localStorage.getItem(TOKEN_KEY) || null;
    } catch (_) {
      return null;
    }
  },

  async setToken(token, days = 1) {
    if (isNative()) {
      try { await Preferences.set({ key: TOKEN_KEY, value: token }); } catch {}
      return;
    }
    Cookies.set(TOKEN_KEY, token, {
      expires: days,
      path: '/',
      sameSite: 'lax',
      secure: window.location.protocol === 'https:',
    });
    try {
      window.localStorage.setItem(TOKEN_KEY, token);
    } catch {}
  },

  async removeToken() {
    if (isNative()) {
      try { await Preferences.remove({ key: TOKEN_KEY }); } catch {}
      return;
    }
    Cookies.remove(TOKEN_KEY, { path: '/' });
    try {
      window.localStorage.removeItem(TOKEN_KEY);
    } catch {}
  },

  async getRefreshToken() {
    if (isNative()) {
      try {
        const { value } = await Preferences.get({ key: REFRESH_TOKEN_KEY });
        return value || null;
      } catch (_) { return null; }
    }
    try {
      return window.localStorage.getItem(REFRESH_TOKEN_KEY) || null;
    } catch (_) {
      return null;
    }
  },

  async setRefreshToken(token) {
    if (isNative()) {
      try { await Preferences.set({ key: REFRESH_TOKEN_KEY, value: token }); } catch {}
      return;
    }
    try {
      window.localStorage.setItem(REFRESH_TOKEN_KEY, token);
    } catch {}
  },

  async removeRefreshToken() {
    if (isNative()) {
      try { await Preferences.remove({ key: REFRESH_TOKEN_KEY }); } catch {}
      return;
    }
    try {
      window.localStorage.removeItem(REFRESH_TOKEN_KEY);
    } catch {}
  },
};
